/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import CircularProgress from "@mui/material/CircularProgress";

import IconLeftButton from "../buttonVariants/IconLeftButton";
import { BUTTON_SIZES } from "../types";

interface ButtonLoaderProps {
  circularProgressColor: string;
  circularProgressSize: number;
  buttonVariant: TemplateStringsArray;
  loaderTitle?: string;
}

const ButtonLoader = ({
  circularProgressColor,
  circularProgressSize,
  buttonVariant,
  loaderTitle
}: ButtonLoaderProps) => {
  return (
    <>
      {!loaderTitle && (
        <CircularProgress
          data-testid="circular-progress"
          size={circularProgressSize}
          sx={{
            color: circularProgressColor,
            position: "absolute",
            left: `calc(50% - ${circularProgressSize / 2}px)`
          }}
        />
      )}
      {loaderTitle && (
        <div css={css(buttonVariant)}>
          <IconLeftButton
            data-testid="circular-progress-with-text"
            title={loaderTitle}
            size={BUTTON_SIZES.Normal}
            icon={
              <CircularProgress
                size={circularProgressSize}
                sx={{
                  color: circularProgressColor
                }}
              />
            }
          />
        </div>
      )}
    </>
  );
};

export default ButtonLoader;
